import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ModalService } from '@shopping-angular-components/modal';
import { WizumenDetailComponent } from '../components/wizumen/wizumen-modal/wizumen-detail.component';
import { IncentiveXSell, IncentiveXSellStorage, WizumenModel, XSellBanner } from '../components/wizumen/wizumen-models';
import { LoaderComponent } from '@shopping-angular-components/loader';
import { LandingModelService } from './landingModel.service';
import { isPlatformBrowser } from '@angular/common';

declare var window: any;
@Injectable({
  providedIn: 'root'
})
export class WizumenService {
  isWebView: boolean;
  wizumenDataMap: { [key: string]: WizumenModel } = {};

  private readonly KEY_INCENTIVE_XSELL = "nymeria-wizumen-xsell";

  constructor(@Inject(PLATFORM_ID) private platformId: string,
    private httpClient: HttpClient, private modalService: ModalService, landingModelService: LandingModelService) {
    this.isWebView = landingModelService.getLandingModel().webview;
  }

  public openModal(flow: string, myTravelsHref: string, moduleId: string, moduleIndex: number, uniqueId: string, tripId: string, tripStatus: string): void {
    const wizumenData: WizumenModel = this.wizumenDataMap[tripId];
    if (wizumenData) {
      this.showModal(flow, myTravelsHref, moduleId, moduleIndex, uniqueId, wizumenData);
    }
    else {
      this.getWizumenData(tripId, flow, myTravelsHref, moduleId, moduleIndex, uniqueId, tripStatus);
    }
  }

  private getWizumenData(tripId: string, flow: string, myTravelsHref: string, moduleId: string, moduleIndex: number, uniqueId: string, tripStatus: string): void {
    LoaderComponent.showLoaderEvent.emit(true);
    const upaData = window.upaData;
    const headers = new HttpHeaders();
    headers.append('X-UOW', upaData.xuowHeader);
    const domain = window.upaData.dn.replace(/:\d+/, '');

    this.httpClient.get(`/nymeria-gui/data/model/wizumen?domain=${domain}&tripId=${tripId}&tripStatus=${tripStatus}&pageview_id=${upaData.pageview_id}`, { headers })
      .subscribe(
        (res: any) => {
          LoaderComponent.showLoaderEvent.emit(false);
          if (res?.items?.[0] != null) {
            this.wizumenDataMap[tripId] = res.items[0];
            this.showModal(flow, myTravelsHref, moduleId, moduleIndex, uniqueId, this.wizumenDataMap[tripId]);
          }
        },
        (error) => {
          LoaderComponent.showLoaderEvent.emit(false);
        }
      );
  }

  private showModal(flow: string, myTravelsHref: string, moduleId: string, moduleIndex: number, uniqueId: string, wizumenData: WizumenModel): void {
    this.modalService.showModal({
      id: "wizumen-modal",
      product: "nymeria-gui",
      flow: flow,
      isWebview: this.isWebView,
      contentComponent: WizumenDetailComponent,
      contentModel: {
        wizumenItem: wizumenData,
        myTravelsHref: myTravelsHref,
        moduleId: moduleId,
        moduleIndex: moduleIndex,
        uniqueId: uniqueId,
      },
      closeOnOutsideClick: true,
    })
  }

  public getIncentiveXSellLocalStorage(tripId: string) {
    if (isPlatformBrowser(this.platformId)) {
      const item = localStorage.getItem(this.KEY_INCENTIVE_XSELL);
      if (item !== null && tripId === JSON.parse(item).tripId) {
        return JSON.parse(item)
      }
      // Si hay un incentivo y no tiene el mismo TripId lo borro
      localStorage.removeItem(this.KEY_INCENTIVE_XSELL)
      return null;
    }
  }

  public saveIncentiveXSellLocalStorage(value: IncentiveXSell) {
    if (isPlatformBrowser(this.platformId)) {
      let xSellBuilder: IncentiveXSellStorage;
      const incentiveStored = this.getIncentiveXSellLocalStorage(value.tripId)
      if (incentiveStored) {
        incentiveStored.hideIncentives.push(value.type);
        xSellBuilder = incentiveStored;
      } else {
        xSellBuilder = {
          tripId: value.tripId,
          hideIncentives: [value.type]
        };
      }
      const item = JSON.stringify(xSellBuilder);
      localStorage.setItem(this.KEY_INCENTIVE_XSELL, item);
    }
  }

  public containsXSellAlert(xSellBanner: XSellBanner | undefined) {
    return !!xSellBanner?.links.some(link => link.type?.toString() === 'XSELL_ALERT');
  }
}
